export default __webpack_public_path__ + "static/media/ph_vertical.bdfa8ebc.png";